let isHistoricalData = false;

const GigRequestGlobalFilterService = (function () {
    const setIsHistorical = function (value: boolean) {
        isHistoricalData = value;
    };

    const getIsHistorical = function (): boolean {
        return isHistoricalData;
    };

    const clearIsHistorical = function () {
        isHistoricalData = false;
    };

    return {
        setIsHistorical,
        getIsHistorical,
        clearIsHistorical
    };
})();

export default GigRequestGlobalFilterService;
